import { TeacherPedagogySubform } from "@user-management-context/primary/teacher/teacher-pedagogy-subform/teacher-pedagogy.subform";

export const PedagogyStep = () => {
  return <TeacherPedagogySubform />;
};
